import { call, put, takeEvery } from "redux-saga/effects"
import {
    GET_ADMIN_REFUND_REASON,
    POST_ADMIN_REFUND_REASON,
    UPDATE_ADMIN_REFUND_REASON,
    DELETE_ADMIN_REFUND_REASON,
} from "./actionTypes"
import {
    getAdminRefundReasonError,
    getAdminRefundReasonSuccess,
    postAdminRefundReasonSuccess,
    postAdminRefundReasonError,
    updateAdminRefundReasonSuccess,
    updateAdminRefundReasonError,
    deleteAdminRefundReasonSuccess,
    deleteAdminRefundReasonError,
} from "./actions"
import {
    genericDeleteRequest,
    genericGetRequest, genericPostRequest, genericPutRequest
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"

function* onGetAdminRefundReason(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_refund_reasons`,
            action.payload?.queryParams,
            {
                Authorization: user.token,
            }
        )
        yield put(getAdminRefundReasonSuccess(response))
    } catch (error) {
        yield put(getAdminRefundReasonError(error))
    }
}

function* onPostAdminRefundReason(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const URL = `${AppConfiguration.BACKEND_URL}/api/v1/admin_refund_reasons`;
        const payload = {
            body: JSON.stringify({
                ...action.payload,
            }),
            headers: {
                Authorization: user.token,
                'Content-Type': 'application/json'
            }   
        }
        const response = yield call(genericPostRequest, URL, payload)
        yield put(postAdminRefundReasonSuccess(response))
    } catch (error) {
        yield put(postAdminRefundReasonError(error))
    }
}

function* onUpdateAdminRefundReason(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericPutRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_refund_reasons/${action.payload?.id}`,
            {
                body: JSON.stringify({
                    ...action.payload,
                }),
                headers: {
                    Authorization: user.token,
                    'Content-Type': 'application/json'
                }
            }
        )
        yield put(updateAdminRefundReasonSuccess(response))
    } catch (error) {
        yield put(updateAdminRefundReasonError(error))
    }
}

function* onDeleteAdminRefundReason(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericDeleteRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_refund_reasons/${action.payload?.id}`,
            {
                body: JSON.stringify({
                    ...action.payload,
                }),
                headers: {
                    Authorization: user.token,
                    'Content-Type': 'application/json'
                }
            }
        )
        yield put(deleteAdminRefundReasonSuccess(response))
    } catch (error) {
        yield put(deleteAdminRefundReasonError(error))
    }
}

function* AdminRefundReasonsSaga() {
    yield takeEvery(GET_ADMIN_REFUND_REASON, onGetAdminRefundReason)
    yield takeEvery(POST_ADMIN_REFUND_REASON, onPostAdminRefundReason)
    yield takeEvery(UPDATE_ADMIN_REFUND_REASON, onUpdateAdminRefundReason)
    yield takeEvery(DELETE_ADMIN_REFUND_REASON, onDeleteAdminRefundReason)
}

export default AdminRefundReasonsSaga;

